import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
    return (
        <section className="min-h-[70vh] flex items-center justify-center px-6" data-testid="not-found-page">
            <div className="text-center max-w-lg">
                <p className="uppercase tracking-[0.3em] text-xs text-safety mb-4">404</p>
                <h1 className="font-display text-5xl md:text-6xl font-extrabold tracking-tight text-charcoal">
                    Page not found
                </h1>
                <p className="mt-4 text-muted-foreground">
                    The page you were looking for got misplaced. Let's head back to the shop.
                </p>
                <Link to="/" className="inline-block mt-8">
                    <Button data-testid="not-found-home-btn" className="rounded-full bg-charcoal hover:bg-charcoal-800 text-white h-12 px-6">
                        <ArrowLeft className="w-4 h-4 mr-2" /> Back to home
                    </Button>
                </Link>
            </div>
        </section>
    );
}
